import type { PDFPageView, PDFViewer } from 'pdfjs-dist/web/pdf_viewer.mjs';

/** PDF.js page numbers are 1-based; getPageView indexes pages from 0. */
export function getPdfPageView(
  viewer: PDFViewer | null | undefined,
  pageNumber: number
): PDFPageView | undefined {
  return viewer?.getPageView(pageNumber - 1) as PDFPageView | undefined;
}
